import { CheckMark } from "./CheckMark";

export default CheckMark;
